export default {
  computed: {
    schemaPerkembangan2023() {
      const bulan = this.$getDeepObj(this.info, 'bulan') || '';
      let instrumens = [];

      const instrumenAbsensi = {
        type: 'VAutocomplete',
        name: 'absensi',
        label: 'Daftar FSP yang hadir',
        placeholder: 'Pilih FSP yang hadir',
        labelColor: 'indigo',
        hint: 'wajib diisi',
        slot: 'selection',
        items: this.listFspDampingan || [],
        grid: { cols: 12, md: 6 },
        multiple: true,
        outlined: true,
        dense: true,
        singleLine: true,
        hideDetails: true,
      };

      for (const ins of this.listInstrumen['progres']) {
        if (+ins.id === 81) {
          instrumens = [
            ...instrumens,
            ...[Object.assign({}, ins, { grid: { cols: 12, md: 6 } })],
            ...[
              Object.assign({}, instrumenAbsensi, {
                exist: { status: +this.form[`instrumen-radio-81`] === 202 },
                name: 'absensi-fsp',
                label: 'FSP yang absen dalam forum',
                placeholder: 'Pilih FSP yang absen',
              }),
            ],
          ];
        } else if (+ins.id === 83) {
          instrumens = [
            ...instrumens,
            ...[Object.assign({}, ins, { grid: { cols: 12, md: +this.form[`instrumen-radio-83`] === 222 ? 6 : 12 } })],
            ...[
              Object.assign({}, instrumenAbsensi, {
                exist: { status: +this.form[`instrumen-radio-83`] === 222 },
                name: 'absensi-sekolah',
                label: 'FSP yang absen dalam PMO level sekolah angkatan 3',
                placeholder: 'Pilih FSP yang absen',
              }),
            ],
          ];
        } else if (+ins.id === 84) {
          instrumens = [
            ...instrumens,
            ...[Object.assign({}, ins, { exist: { status: [221, 222].includes(+this.form[`instrumen-radio-83`]) } })],
          ];
        } else if (+ins.id === 85) {
          instrumens = [
            ...instrumens,
            ...[Object.assign({}, ins, { grid: { cols: 12, md: 6 } })],
            ...[
              Object.assign({}, instrumenAbsensi, {
                exist: { status: +this.form[`instrumen-radio-85`] === 242 },
                name: 'absensi-lokakarya',
                label: 'FSP yang absen dalam forum',
                placeholder: 'Pilih FSP yang absen',
              }),
            ],
          ];
        } else if (+ins.id === 87) {
          instrumens = [
            ...instrumens,
            ...[Object.assign({}, ins, { grid: { cols: 12, md: 6 } })],
            ...[
              Object.assign({}, instrumenAbsensi, {
                exist: { status: +this.form[`instrumen-radio-87`] === 262 },
                name: 'absensi-disiplin',
                label: 'FSP yang terlambat mengumpulkan laporan pendampingan',
                placeholder: 'Pilih FSP',
              }),
            ],
          ];
        } else {
          instrumens.push(ins);
        }
      }

      return {
        kegiatan: {
          title: 'Pekembangan Pendampingan FSP',
          laporan: [
            ...[
              {
                type: 'textView',
                label: 'Bulan Pelaksanaan',
                labelColor: 'indigo',
                bgColor: 'grey lighten-3 pa-2 mb-4',
                value: bulan || '',
                grid: { cols: 12 },
              },
            ],
            ...instrumens,
          ],
        },
      };
    },
  },
};
